import { z } from "zod";
import { UuidField, TimestampField } from "./common";

const Provider = z.enum(["google", "microsoft", "github", "dropbox"]);

const ConnectAccountRequest = z.object({
  provider: Provider,
  workspaceId: UuidField,
  scopes: z.array(z.string()).optional(),
});
const ConnectAccountResponse = z.object({
  authUrl: z.url(),
  state: z.string(),
});
const AccountCallbackRequest = z.object({
  code: z.string(),
  state: z.string(),
  provider: Provider,
});
const ConnectedAccount = z.object({
  id: UuidField,
  provider: Provider,
  email: z.email(),
  displayName: z.string(),
  avatar: z.url().optional(),
  scopes: z.array(z.string()).optional(),
  isActive: z.boolean(),
  connectedAt: TimestampField,
  lastSyncAt: TimestampField.optional(),
});
const ConnectedAccountsList = z.object({
  accounts: z.array(ConnectedAccount),
  total: z.number().int(),
});
const Workspace = z.object({
  id: UuidField,
  name: z.string(),
  description: z.string().optional(),
  isDefault: z.boolean(),
  createdAt: TimestampField.optional(),
  updatedAt: TimestampField.optional(),
});
const WorkspacesList = z.object({
  workspaces: z.array(Workspace),
  total: z.number().int(),
});
const Email = z.object({
  id: z.string(),
  subject: z.string(),
  from: z.string(),
  to: z.array(z.string()).optional(),
  date: TimestampField,
  snippet: z.string(),
  isRead: z.boolean().optional(),
  labels: z.array(z.string()).optional(),
});
const EmailsList = z.object({
  emails: z.array(Email),
  total: z.number().int(),
  hasMore: z.boolean(),
  nextPageToken: z.string().optional(),
});
const File = z.object({
  id: z.string(),
  name: z.string(),
  mimeType: z.string(),
  size: z.number().int(),
  modifiedTime: TimestampField,
  downloadUrl: z.url().optional(),
  thumbnailUrl: z.url().optional(),
  isFolder: z.boolean().optional(),
});
const FilesList = z.object({
  files: z.array(File),
  total: z.number().int(),
  hasMore: z.boolean(),
  nextPageToken: z.string().optional(),
});
export const schemas = {
  ConnectAccountRequest,
  ConnectAccountResponse,
  AccountCallbackRequest,
  ConnectedAccount,
  ConnectedAccountsList,
  Workspace,
  WorkspacesList,
  Email,
  EmailsList,
  File,
  FilesList,
};

// oRPC Type Inference Support
// These types enable proper oRPC client generation and type inference

export type SchemaTypes = {
  [K in keyof typeof schemas]: z.infer<(typeof schemas)[K]>;
};

// Re-export for convenient access
export type * from "zod";
